import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=3abf1009&"
import script from "./Logout.vue?vue&type=script&lang=ts&"
export * from "./Logout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Logout.vue"
export default component.exports